import $ from 'jquery';

class ToggleOpen {
    constructor (groupHeading, groupWrapper) {
        this.$heading      = $(groupHeading);
        this.$contentClass = groupWrapper;

        this.$heading.on('click', $.proxy(this.buttonClick, this));
    }

    buttonClick (e) {
        e.preventDefault();
        this.$heading.toggleClass('is-clicked').parent().find(this.$contentClass).slideToggle();

        if (this.$heading.hasClass('is-clicked')) {
            this.$heading.find('span').text('Hide');
        } else {
            this.$heading.find('span').text('Read more');
        }
    }
}

export default ToggleOpen;
